type FilterStageIconProps = {
  color?: string | null;
  order?: number | null;
};

/**
 * Small numbered stage badge used inside the Filters2 stage pickers
 * (trigger icon + option icons). Named `FilterStageIcon` to avoid a
 * collision with the shared `StageIcon` exported from
 * `@poseidon/components/Input2`.
 */
export function FilterStageIcon({ color, order }: FilterStageIconProps) {
  return (
    <div
      className="size-4 rounded-full shrink-0 flex items-center justify-center text-white font-semibold"
      style={{ backgroundColor: color ?? undefined, fontSize: '9px' }}>
      {order ?? '?'}
    </div>
  );
}
